import { render, staticRenderFns } from "./AdjustmentProposals.vue?vue&type=template&id=2725d8ae"
import script from "./AdjustmentProposals.vue?vue&type=script&lang=js"
export * from "./AdjustmentProposals.vue?vue&type=script&lang=js"
import style0 from "./AdjustmentProposals.vue?vue&type=style&index=0&id=2725d8ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports